import { Action } from "redux";
import { fetchOrdersReqBodyType, Order, OrdersSuccessPayload } from "./types";
import { OrdersActionTypes } from "./types/actionTypes";

// ACTION INTERFACE

export interface fetchOrdersInterface extends Action<OrdersActionTypes> {
  type: OrdersActionTypes.FETCH_ORDERS_SAGA;
  payload: { params: URLSearchParams; isActiveOrders: boolean; setParams?: () => void};
}

export interface fetchOrdersSuccessInterface extends Action<OrdersActionTypes> {
  type: OrdersActionTypes.FETCH_ORDERS_SUCCESS;
  payload: OrdersSuccessPayload;
}

export interface fetchOrdersErrorInterface extends Action<OrdersActionTypes> {
  type: OrdersActionTypes.FETCH_ORDERS_ERROR;
}

export interface fetchOrdersErrorMessageInterface
  extends Action<OrdersActionTypes> {
  type: OrdersActionTypes.FETCH_ORDER_ERROR_MESSAGE_SAGA;
  payload: { order_id: string; restaurant_id: string };
}

export interface fetchOrderErrorMessageSuccessInterface
  extends Action<OrdersActionTypes> {
  type: OrdersActionTypes.FETCH_ORDER_ERROR_MESSAGE_SUCCESS;
  payload: string;
}

export interface clearOrderErrorMessageInterface
  extends Action<OrdersActionTypes> {
  type: OrdersActionTypes.CLEAR_ORDER_ERROR_MESSAGE;
}

//  ACTION CREATORS 

export const fetchOrders = (
  params: URLSearchParams,
  isActiveOrders: boolean,
  setParams?: () => void
): fetchOrdersInterface => {
  return {
    type: OrdersActionTypes.FETCH_ORDERS_SAGA,
    payload: { params, isActiveOrders, setParams },
  };
};

export const fetchOrdersSuccess = (
  payload: OrdersSuccessPayload
): fetchOrdersSuccessInterface => ({
  type: OrdersActionTypes.FETCH_ORDERS_SUCCESS,
  payload,
});

export const fetchOrdersError = (): fetchOrdersErrorInterface => ({
  type: OrdersActionTypes.FETCH_ORDERS_ERROR,
});

export const fetchOrderErrorMessage = (
  restaurant_id: string,
  order_id: string
): fetchOrdersErrorMessageInterface => {
  return {
    type: OrdersActionTypes.FETCH_ORDER_ERROR_MESSAGE_SAGA,
    payload: { order_id, restaurant_id },
  };
};

export const fetchOrderErrorMessageSuccess = (
  payload: string
): fetchOrderErrorMessageSuccessInterface => {
  return {
    type: OrdersActionTypes.FETCH_ORDER_ERROR_MESSAGE_SUCCESS,
    payload,
  };
};

export const clearOrderErrorMessage = (): clearOrderErrorMessageInterface => {
  return {
    type: OrdersActionTypes.CLEAR_ORDER_ERROR_MESSAGE,
  };
};

// ORDERS ALL ACTIONS

export type OrdersActions =
  | fetchOrdersInterface
  | fetchOrdersSuccessInterface
  | fetchOrdersErrorInterface
  | fetchOrdersErrorMessageInterface
  | fetchOrderErrorMessageSuccessInterface
  | clearOrderErrorMessageInterface;
